(function() {
  if (Object.hasOwn) {
    return;
  }

  Object.hasOwn = function(object, property) {
    if (typeof object === 'undefined' || object === null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    return Object.prototype.hasOwnProperty.call(Object(object), property);
  };
}());
